module.exports = __webpack_public_path__ + "static/media/router-24px.c26aa915.svg";